<template>
  <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
      v-if="$store.state.user.data"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ $store.state.user.data.name }}
        </p>
        <span class="user-status">{{ $store.state.user.data.roleName }}</span>
      </div>
      <b-avatar
          size="40"
          :src="$store.state.user.data.avatar"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
      >
        <feather-icon
            v-if="!$store.state.user.data.name"
            icon="UserIcon"
            size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
        :to="{ name: 'pages-profile'}"
        link-class="d-flex align-items-center"
    >
      <feather-icon
          size="16"
          icon="UserIcon"
          class="mr-50"
      />
      <span>پروفایل</span>
    </b-dropdown-item>
    <template v-if="$store.state.user.data && $store.state.user.data.profiles.length > 0">
      <b-dropdown-divider/>

      <b-dropdown-item v-for="profile in $store.state.user.data.profiles"
                       link-class="d-flex align-items-center"
                       @click="loginToUser(profile.id)"
      >
        <span><small>ورود با :</small> {{ profile.name }}</span>
      </b-dropdown-item>
    </template>

    <b-dropdown-divider/>

    <b-dropdown-item
        link-class="d-flex align-items-center"
        variant="danger"
        @click="logout"
    >
      <feather-icon
          size="16"
          icon="LogOutIcon"
          class="mr-50"
      />
      <span>خروج</span>
    </b-dropdown-item>

  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BDropdownGroup
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import { doubleRaf } from '@/libs/utils'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BDropdownGroup
  },
  data() {
    return {
      userData: this.$store.state.user.data,
      avatarText,
    }
  },
  methods: {
    logout() {
      // this.$store.commit('user/UPDATE_USER_TOKEN', null)
      this.$store.commit('user/UPDATE_USER_DATA', null)
      this.$cookies.remove('token')
      this.$http.post('user/auth/logout')
          .then(() => {
            this.$router.push({ name: 'auth-login' })
            this.$cookies.remove('token')

          })
    },
    loginToUser(id) {
      this.$http.post(`user/login-by-id/${id}`)
          .then((data) => {
            this.$store.commit('user/UPDATE_USER_DATA', data.user)
            this.$store.commit('user/UPDATE_USER_REDIRECT_FROM', data.redirect_from)
            this.$router.replace({ name: 'reloadPage' })
            // window.location.reload()
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? error.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    }
  },
}
</script>
